/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Charactergreetingmars2Inputs */



/**
* | output |
* | --- |
* | "What's up, troublemaker? 😈" |
*
* @param {Charactergreetingmars2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const charactergreetingmars2 = /** @type {((inputs?: Charactergreetingmars2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Charactergreetingmars2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("What's up, troublemaker? 😈")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Qué pasa, alborotador? 😈")
	return /** @type {LocalizedString} */ ("Как дела, troublemaker? 😈")
});
export { charactergreetingmars2 as "characterGreetingMars" }